import { BasicRequest } from '@/api/api'
import { Picture } from '@/types/schema/api/file'
import { PlatformShortcode } from '@/utils/convert-platform'

export interface FetchFeedbackAnalyzeRequest extends BasicRequest {
  kol_uuid: string
  platform_type: PlatformShortcode
}

export enum FeedbackType {
  Audience = 'audience',
  AudienceAuthenticity = 'audience-authenticity',
  Advertorial = 'advertorial',
  CustomizedTag = 'customized-tag',
}

export interface SubmitAnalyzeFeedbackRequest extends BasicRequest {
  feedbackType: FeedbackType
  kol_uuid: string
  platform_type: PlatformShortcode
  reason?: string
  pictures?: Picture[]
  is_accurate: boolean
}
